import DOMPurify from 'dompurify';
import { action, computed, makeObservable } from 'mobx';

import { IFormFieldOptions } from '@/stores/interfaces/IFormField';
import { IFormStore } from '@/stores/interfaces/IFormStore';
import { normalizeStringValue } from '@/utils/normalizers';

import { FieldStore } from '../FieldStore';

export type Value = string | null;
type ToServerData = string | null;

export type FieldTextStoreOptions = Partial<IFormFieldOptions<Value>> & {
  sanitize?: boolean;
};

export class FieldTextStore extends FieldStore<Value> implements IFormStore<any, ToServerData> {
  private _sanitize: boolean;

  constructor(options?: FieldTextStoreOptions) {
    super({ ...options, defaultValue: options?.defaultValue ?? null });

    this._sanitize = options?.sanitize ?? true;

    makeObservable(this, {
      serverFormat: computed,
      setFromServerFormat: action.bound,
    });
  }

  /** Заполняет значение поле из серверных данных **/
  setFromServerFormat<T>(from: T): void {
    this.setValue(normalizeStringValue(from), { noTouch: true });
  }

  /** Значение поле в серверном формате **/
  get serverFormat(): ToServerData {
    if (this.value === null) {
      return null;
    }

    return this._sanitize ? DOMPurify.sanitize(this.value) : this.value;
  }
}
